import { toQueryString } from 'utils/utils';
import { fetchResponseWithProgress } from 'utils/fetchProgress';

const SEGMENT_API_ROOT = 'https://service-selfie-segment.pow.io';
export async function selfieSegmentApi({ method, path, query, body, onProgress }) {
	if (typeof window === 'undefined') {
		throw new Error('Trying to request server-side');
	}

	let url = `${SEGMENT_API_ROOT}${path || '/'}`;
	if (query) {
		url += toQueryString(query);
	}

	const fetchOptions = { method };

	if (body) {
		fetchOptions.headers = { 'content-type': 'application/json' };
		fetchOptions.body = JSON.stringify(body);
	}

	const res = await fetch(url, fetchOptions);

	if (!res.ok) {
		throw res.status || res.error || res;
	}

	if (onProgress) {
		return fetchResponseWithProgress(res, 'json', onProgress);
	}
	return res.json();
}

export const stripBase64Info = (imageData) => imageData.replace(/^data:image\/(\w+);base64,/, '');

export const addBase64Info = (imageData) => {
	if (!imageData) return;
	if (imageData.startsWith('iVBOR')) {
		return `data:image/png;base64,${imageData}`;
	} else if (imageData.startsWith('/9j/')) {
		return `data:image/jpeg;base64,${imageData}`;
	} else if (imageData.startsWith('UklGR')) {
		return `data:image/webp;base64,${imageData}`;
	}
	return imageData;
};
